import { publicApiFetch } from "@/utils/publicApi";

export interface EmailChangePublicMeta {
  new_email: string;
  current_email: string;
}

export interface ConfirmEmailChangeResponse {
  detail: string;
  email: string;
}

export const emailChangeService = {
  getByToken: (token: string) =>
    publicApiFetch<EmailChangePublicMeta>(`/auth/email-change/${encodeURIComponent(token)}/`),

  confirm: (token: string) =>
    publicApiFetch<ConfirmEmailChangeResponse>(
      `/auth/email-change/${encodeURIComponent(token)}/confirm/`,
      { method: "POST", body: "{}" }
    ),
};
